import { Component } from '@angular/core';

@Component({
    selector: 'app-partners',
    templateUrl: './partners.component.html',
    styleUrls: ['./partners.component.scss'],
    standalone: true
})
export class PartnersComponent {

  joinWebinar() {
    window.open('/webinar', '_blank');
  }



}
